import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import {
  AdminPermission,
  getDefaultAuthorizedRoute,
} from "helpers/auth/rbac";

type Props = {
  children: JSX.Element;
  permissions?: AdminPermission[];
  requireAll?: boolean;
};

function RequireAuth({ children, permissions, requireAll = true }: Props) {
  const { canAll, canAny, isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (permissions?.length) {
    const isAuthorized = requireAll
      ? canAll(permissions)
      : canAny(permissions);

    if (!isAuthorized) {
      return (
        <Navigate
          to={getDefaultAuthorizedRoute(user)}
          replace
          state={{ from: location }}
        />
      );
    }
  }

  return children;
}

export default RequireAuth;
